import { TRecommendation } from '../../types/recommendation';
import { IApplicationState } from '../../types/redux';

export const selectRecommendationById =
  (id: number) =>
  (state: IApplicationState): TRecommendation => {
    return state.recommendations?.recommendations.find(({ offerId }) => offerId === id) || ({} as TRecommendation);
  };
